import axios from '@tw/shared-ui-components/lib/utils/axios_interceptor';

import { getPdmApiUrl } from "../../../common/utils/helper";
const SET_HOME_STATE = "SET_HOME_STATE";
export const SET_ANNOUNCEMENT = "SET_ANNOUNCEMENT";

export const setHomeState = (state) => {
  return {
    type: SET_HOME_STATE,
    payload: state,
  };
};

export const setAnnouncement = (announcement) => ({
  type: SET_ANNOUNCEMENT,
  payload: announcement,
});

export const fetchHomeState = () => async (dispatch) => {
  const apiUrl = getPdmApiUrl();
  const res = await axios.post(
    `/home-page`,
    {},
    {
      baseURL: apiUrl,
    }
  );

  dispatch(setHomeState(res.data));
};

const homeState = (state = {}, action) => {
  switch (action.type) {
    case SET_HOME_STATE:
      return action.payload;
    case SET_ANNOUNCEMENT:
      return {
        ...state,
        announcement: action.payload,
      };
    default:
      return state;
  }
};

export default {
  homeState,
};
